/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

// src/utils/api.js
// API çağrıları için merkezi helper fonksiyonlar

// ✅ Authenticated fetch - Cookie otomatik gönderilir (HttpOnly)
// Backend cookie'den okuyor (multi-worker uyumlu), Authorization header'a gerek yok
// Güvenlik: Tüm error'lar merkezi error handler ile işlenir
import { handleApiResponse } from './errorHandler';

// Production'da environment variable'dan al, yoksa localhost kullan
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const apiFetch = async (endpoint, options = {}) => {
  const url = endpoint.startsWith("http") ? endpoint : `${API_URL}${endpoint}`;

  const config = {
    ...options,
    credentials: "include", // Cookie'yi gönder (HttpOnly cookie otomatik gönderilir)
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);
    // Merkezi error handling - 401 ve diğer hatalar burada işlenir
    return await handleApiResponse(response, `API: ${endpoint}`);
  } catch (error) {
    // handleApiResponse'dan gelen error'ları (401, 403, 404, vb.) direkt fırlat
    // Bu error'lar zaten doğru mesajlarla geliyor
    if (error.status || error.message === "Oturum süresi doldu") {
      throw error;
    }
    
    // Sadece gerçek network error'lar için (fetch başarısız olduğunda)
    // Network error - SADECE development'ta console'a yaz
    if (process.env.NODE_ENV === 'development') {
      console.error('[API Fetch] Network Error:', {
        endpoint,
        error: error.message,
      });
    }
    
    throw new Error("Sunucuya bağlanılamıyor. İnternet bağlantınızı kontrol edin.");
  }
};

// ✅ Kolay kullanım için yardımcı metodlar
export const api = {
  get: (endpoint) => apiFetch(endpoint, { method: "GET" }),
  
  post: (endpoint, data) => apiFetch(endpoint, {
    method: "POST",
    body: JSON.stringify(data),
  }),
  
  put: (endpoint, data) => apiFetch(endpoint, {
    method: "PUT",
    body: JSON.stringify(data),
  }),
  
  patch: (endpoint, data) => apiFetch(endpoint, {
    method: "PATCH",
    body: JSON.stringify(data),
  }),
  
  delete: (endpoint) => apiFetch(endpoint, { method: "DELETE" }),
};

export default api;

